import React, { useState } from 'react'
import classNames from 'classnames'
import { kebabCase } from 'lodash'
import { Link as ScrollLink } from 'react-scroll'
import PageContent from '#src/components/PageContent'
import Section from '../Section'
import { BodyContent as BodyContentProps } from '../schema'
import styles from './styles.css'

interface Props extends BodyContentProps {
  sectionTitleOverride?: string
  message?: string
}

const BodyContent: React.SFC<Props> = ({
  sections,
  sectionTitle,
  sectionTitleOverride,
  message
}) => {
  const [activeSection, handleChangeActiveSection] = useState(0)

  return (
    <PageContent className={styles.wrapper}>
      <div className={styles.title}>{sectionTitleOverride || sectionTitle || 'Full Itinerary'}</div>
      {message && <p className={styles.message}>{message}</p>}

      <div className={styles.container}>
        <div className={styles.controlsContainer}>
          <ul className={styles.itineraryControls}>
            {sections &&
              sections.filter(i => i.header).map((section, index) => {
                const key = kebabCase(section.header)
                return (
                  <li key={key}>
                    <ScrollLink
                      smooth
                      to={key}
                      className={classNames({
                        [styles.controlsItem]: true,
                        [styles.active]: index === activeSection
                      })}
                      onClick={() => handleChangeActiveSection(index)}
                    >
                      <span className={styles.radio}>
                        <span className={styles.centerRadio} />
                      </span>
                      {section.subHeader ? (
                        <span>{section.subHeader}</span>
                      ) : (
                        <span>{section.header}</span>
                      )}
                    </ScrollLink>
                  </li>
                )
              })}
          </ul>
        </div>
        <div className={styles.sectionContainer}>
          {sections &&
            sections.filter(i => i.header).map(section => {
              const key = kebabCase(section.header)
              return (
                <div id={key} key={key}>
                  <Section {...section} />
                </div>
              )
            })}
        </div>
      </div>
    </PageContent>
  )
}

export default BodyContent
